<template>
    <v-container fluid style="padding:0px 10px 5px 10px;width:100%;">
        <v-layout column>
            <v-flex>
                <v-card style="height:100%;width:100%;">
                    <v-layout column fill-height>
                        <v-flex v-for="tag in ['kpi','sfoc']" :key="tag" d-flex md6>
                            <v-layout row v-if="gaugeData[tag]">
                                <v-flex class="title" style="align-items:center;padding:15px;" d-flex md3>{{gaugeData[tag].title}}</v-flex>
                                <v-flex d-flex md9>
                                    <hor-gauge :value="gaugeData[tag].value" :maxValue="gaugeData[tag].maxValue" :minValue="gaugeData[tag].minValue" :color="gaugeData[tag].color"/>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-card>
            </v-flex>
            <v-flex>
                <v-card :style="'max-height: ' + gaugeListHeight + 'px; width:100%;'">
                    <v-card-title primary class="title" style="height:15%;width:100%;padding-top:5px;padding-bottom:5px;">Subsystems KPI</v-card-title>
                    <v-card-actions style="max-height: 300px; width:100%; margin-top:-50px; padding-top:0; padding-bottom:0; justify-content: center;" v-for="i in gaugeListRange" :key="i">
                        <v-flex v-for="sys in subSystems.slice(i * 3, i * 3 + 3)" :key="sys" :style="'max-width:'+(100/3)+'%;'">
                            <v-layout column>
                                <v-flex d-flex>
                                    <CircGauge v-if="gaugeData[sys.tag]" v-bind:value="gaugeData[sys.tag].value" v-bind:labelText="gaugeData[sys.tag].value +' %'" v-bind:color="gaugeData[sys.tag].color" v-bind:fontSize="14"/>
                                </v-flex>
                                <v-flex d-flex style="margin-top: -100px; font-size:14px;font-weight:400; align-items:center;justify-content:center; ">{{sys.name}}</v-flex>
                            </v-layout>
                        </v-flex>
                    </v-card-actions>
                </v-card>
            </v-flex>
            <v-flex>
                <v-card>
                    <Chart v-if="chartData['issues']" v-bind:chartOptions="chartData['issues']" v-bind:title="'Issues / Subsystem'" v-bind:active="active"/>
                </v-card>
            </v-flex>
            <v-flex>
                <v-card fluid>
                    <v-card-title primary class="title" style="height:30%;width:100%;padding-top:5px;padding-bottom:5px; margin-right: 10px">Specifications</v-card-title>
                    <v-card-actions style="width:100%;padding-top:0px;padding-bottom:10px;">
                        <dx-data-grid class="grid" :data-source="specifData" :show-column-lines="true" :show-row-lines="true" :show-borders="true" :word-wrap-enabled="true" :row-alternation-enabled="false" :column-auto-width="true">
                            <dx-column data-field="controlSystem" caption="Control System"/>
                            <dx-column data-field="bore" caption="Bore (mm)"/>
                            <dx-column data-field="engSpeed" caption="Engine Speed (rpm)"/>
                            <dx-column data-field="powerSpeed" caption="Power (kW)"/>
                            <dx-column data-field="cylinderNo" caption="Cylinders"/>
                        </dx-data-grid>
                    </v-card-actions>
                </v-card>
            </v-flex>
            <v-flex>
                <v-card fluid fill-height>
                    <v-card-title primary class="title" style="height:15%;width:100%;padding-top:5px;padding-bottom:5px;">{{selEngine}} Issues</v-card-title>
                    <v-card-actions fill-height style="height:85%;width:100%;padding-top:0px;padding-bottom:0px;">
                        <v-layout column style="height:100%;width:100%;">
                            <v-flex>
                                <dx-data-grid class="grid" :data-source="issueData" :show-column-lines="true" :show-row-lines="true" :show-borders="true" :word-wrap-enabled="true" :row-alternation-enabled="false" :column-auto-width="true">
                                    <dx-column data-field="desc" caption="Issue Description"/>
                                    <dx-column data-field="subSys" caption="Subsystem"/>
                                    <dx-column data-field="issueCount" caption="Issue Counter"/>
                                    <dx-column data-field="engCount" caption="Engine Counter" cell-template="btnCell"/>
                                    <div slot="btnCell" slot-scope="{ data: cellData }">{{cellData.value}}</div>
                                </dx-data-grid>
                            </v-flex>

                            <v-flex style="margin-bottom: 40px">
                                <Chart v-if="chartData['topIssues']" v-bind:chartOptions="chartData['topIssues']" v-bind:title="'Top issues'" v-bind:active="active" v-bind:flat="true"/>
                            </v-flex>
                        </v-layout>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

    import Chart from '../components/Chart'
    import HorGauge from '../components/HorGauge'
    import CircGauge from '../components/CircGauge'
    import {DxDataGrid, DxColumn, DxPaging, DxScrolling} from 'devextreme-vue/data-grid';

    export default {
        name: "EngineView",
        components: {
            HorGauge,
            Chart,
            DxDataGrid,
            DxColumn,
            DxPaging,
            DxScrolling,
            CircGauge
        },
        data() {
            return {
                subSystems: [
                    {
                        name: 'Servo Oil',
                        tag: 'so'
                    },
                    {
                        name: 'Fuel Injection',
                        tag: 'fi'
                    },
                    {
                        name: 'Scavenge Air',
                        tag: 'sac'
                    },
                    {
                        name: 'Exhaust Gas',
                        tag: 'egs'
                    },
                    {
                        name: 'Piston Running',
                        tag: 'pr'
                    },
                    {
                        name: 'Autom.- Contr.',
                        tag: 'ca'
                    }
                ],
                chartData: {},
                gaugeData: {},
                gridData: [],
                issueData: [],
                tabActive: 0,
                specifData: [],
                title: 'Tab 1',
                tabTitles: ['Part 1', 'Part 2']
            }
        },
        props: {
            active: Boolean,
            selEngine: String,
            engineData: Object
        },
        computed: {
            gaugeListRange: function () {
                var tmp = [];

                for (var i = 0; i < Math.ceil(this.subSystems.length/3); i++) {
                    tmp.push(i);
                }

                return tmp;
            },
            gaugeListHeight: function () {
                return Math.ceil(this.subSystems.length/3) * 200 + 200
            }
        },
        created() {
        },
        mounted() {
        },
        methods: {
            gridClick(e) {
                if ((e.column.dataField == "vessName") && (e.rowType != "header")) {
                    this.$emit('vesselSelected', e.value);
                }
            },
            cellPrepared(e) {
                if ((e.column.dataField == "vessName") && (e.rowType != "header")) {
                    e.cellElement.classList.add('clickable');
                }
            },
            setData() {
                if (Object.keys(this.engineData).indexOf("gasFaultNo") > -1 && this.engineData['gasFaultNo'] != 0) {
                    if (this.subSystems.filter((i) => {return i.name == 'Gas Admission';}).length < 1) {
                        this.subSystems.push({
                            name: 'Gas Admission',
                            tag: 'gas'
                        })
                    }
                } else {
                    this.subSystems = this.subSystems.filter((i) => {
                        return i.name != 'Gas Admission';
                    })
                }

                this.specifData = [];

                this.specifData.push({
                    "controlSystem": this.engineData.controlSystem,
                    "bore": this.engineData.bore,
                    "engSpeed": this.engineData.engSpeed,
                    "powerSpeed": this.engineData.powerSpeed,
                    "cylinderNo": this.engineData.cylinderNo
                });

                this.$set(this.chartData, 'issues', {
                    chart: {
                        height: 0,
                        zoomType: 'xy'
                    },
                    legend: {
                        enabled: false
                    },
                    xAxis: {
                        categories: this.subSystems.map(function (item) {
                            return item.name;
                        }),
                        crosshair: true
                    },
                    yAxis: {
                        title: {
                            text: undefined
                        }
                    },
                    exporting: {
                        enabled: false
                    },
                    title: {
                        text: undefined
                    },
                    series: [
                        {
                            type: 'column',
                            animation: false,
                            data: [],
                            states: {
                                hover: {
                                    enabled: false
                                },
                                normal: {
                                    animation: false
                                },
                                inactive: {
                                    opacity: 1
                                }
                            }
                        }
                    ],
                    tooltip: {
                        formatter: function () {
                            return this.x + ': ' + this.point.y.toFixed(1);
                        }
                    },
                    credits: {enabled: false}
                });

                for (let i = 0; i < this.subSystems.length; i++) {
                    let tag = this.subSystems[i].tag + 'FaultNo';

                    this.chartData['issues'].series[0].data.push({
                        y: this.engineData[tag],
                        color: 'rgb(144,170,218)'
                    });
                }

                this.gaugeData['kpi'] = {
                    'title': 'Engine KPI',
                    'value': this.engineData.eng_KPI > 0 ? (this.engineData.eng_KPI * 100).toFixed(0) : '-',
                    'maxValue': 100,
                    'minValue': 0,
                    'color': ((this.engineData.eng_KPI_color == 0) ? 'rgb(60, 171, 48)' : ((this.engineData.eng_KPI_color == 10) ? 'rgb(255, 184, 29)' : 'rgb(205, 57, 64)')),
                };

                this.gaugeData['sfoc'] = {
                    'title': 'SFOC',
                    'value': this.engineData.bsfc > 0 ? this.engineData.bsfc.toFixed(2) : '-',
                    'maxValue': 220,
                    'minValue': 150,
                    'color': 'rgb(144,170,218)',
                };

                for (let i = 0; i < this.subSystems.length; i++) {
                    let tag = this.subSystems[i].tag;

                    this.$set(this.gaugeData, this.subSystems[i].tag, {
                        value: ((this.engineData[tag + '_KPI'] < 0) ? '-' : (this.engineData[tag + '_KPI'] * 100).toFixed(0)),
                        color: this.engineData[tag + '_KPI_color']
                    });
                }

                this.gridData = [];

                for (let i = 0; i < this.engineData.engines.length; i++) {
                    let eng = this.engineData.engines[i],
                        compString = '';

                    if (eng.compWithFaults.length > 0)
                        compString = eng.compWithFaults.reduce(function (total, newString) {
                            return total + " / " + newString;
                        });

                    this.gridData.push({
                        shComp: eng.shippingCompany,
                        vessName: eng.vessel,
                        avgKPI: eng.avgEngKPI,
                        minKPI: eng.minEngKPI,
                        comp: compString,
                        freqIss: eng.topFault,
                        lastIss: eng.lastFault
                    });
                }

                this.issueData = [];

                for (let i = 0; i < this.engineData.faults.length; i++) {
                    let fault = this.engineData.faults[i];

                    this.issueData.push({
                        desc: fault.description,
                        subSys: fault.subSystem,
                        issueCount: fault.faultCounter,
                        engCount: fault.engCounter

                    });
                }

                this.$set(this.chartData, 'topIssues', {
                    chart: {
                        height: 0,
                    },
                    exporting: {
                        enabled: false
                    },
                    title: {
                        text: undefined
                    },
                    plotOptions: {
                        pie: {
                            shadow: false,
                            center: ['50%', '50%'],
                            dataLabels: {
                                enabled: false
                            },
                        }
                    },
                    series: [{
                        type: 'pie',
                        animation: false,
                        data: [],
                        size: '100%',
                        innerSize: '70%',
                        states: {
                            hover: {
                                enabled: false
                            },
                            normal: {
                                animation: false
                            },
                            inactive: {
                                opacity: 1
                            }
                        }
                    }],
                    tooltip: {
                        formatter: function () {
                            return this.point.name + ': ' + this.point.y.toFixed(1);
                        }
                    },
                    credits: {enabled: false}
                });

                for (let j = 0; j < this.engineData.topFaults.length; j++) {
                    this.chartData.topIssues.series[0].data.push({
                        y: Number(this.engineData.topFaults[j].percentage),
                        name: this.engineData.topFaults[j].description
                    });
                }
            }
        },
        watch: {
            selEngine: function () {
                this.setData()
            },
            engineData: function () {
                this.setData()
            }
        }
    }

</script>

<style scoped>

    .tabItem {
        height: calc(100vh - 128px)
    }

    .activeTab {
        color: rgb(144, 170, 218) !important;
        opacity: 1 !important;
    }

</style>
